<template>
  <v-list subheader>
    <v-subheader>Recent Chats</v-subheader>
    <v-list-tile avatar v-for="(chat, index) in chats" :key="chat.name" :to="/chat/ + index">
      <v-list-tile-content>
        <v-list-tile-title v-html="chatName(index)" />
      </v-list-tile-content>
      <v-list-tile-action>
        <v-icon>chat_bubble</v-icon>
      </v-list-tile-action>
    </v-list-tile>
  </v-list>
</template>

<script>
  export default{
    data () {
      return {
        recentChats: 'Recent Chats'
      }
    },
    computed: {
      chats () {
        return this.$store.getters.chats
      },
      user () {
        return this.$store.getters.user
      },
      chatName () {
        return (index) => {
          const chat = this.chats[index]
          if (chat.type === 'private') {
            const userId = chat.data.userId
            return `(${chat.userData.newMessages}) user ${userId}`
          } else {
            return `(${chat.userData.newMessages}) ${chat.data.title}`
          }
        }
      }
    }
  }
</script>
